import component from "./ProfileFinishAlert.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileFinishAlert"

export default wrapVueComponent(componentName, component)
